/* eslint-disable import/prefer-default-export, no-multi-spaces */
export const copyToClipboardMixin = {
  methods: {
    // using pure javascript solution instead of Clipboard API due to
    // browser compatibility.
    // https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
    copyStorageLink(container, absolutePath) {
      // construct url based on container & absolutePath of the file
      let storageType = null;
      switch (container) {
        case 'documents':
          storageType = 'documentation';
          break;
        case 'software-downloads':
          storageType = 'software';
          break;
        default:
          // indicate to user that the container is not recognized
          return this.$buefy.toast.open({
            duration: 2000,
            message: 'Storage container not recognized.',
            type: 'is-error'
          });
      }

      const baseUrl = `${window.location.origin}/${storageType}/download?path=`;      
      const el = document.createElement('textarea');  // Create a <textarea> element
      el.value = `${baseUrl}${absolutePath}`;     // set the value to the URL of the file
      el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
      el.style.position = 'absolute';                 
      el.style.left = '-9999px';                      // Move outside the screen to make it invisible
      document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
      // eslint-disable-next-line operator-linebreak
      const selected =
        document.getSelection().rangeCount > 0        // Check if there is any content selected previously
          ? document.getSelection().getRangeAt(0)     // Store selection if found
          : false;   
      el.select();                                    // Select the <textarea> content
      document.execCommand('copy');                   // copy the contents of <textarea>, in this case just the URL
      document.body.removeChild(el);                  // Remove the <textarea> element
      if (selected) {                                 // If a selection existed before copying
        document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
        document.getSelection().addRange(selected);   // Restore the original selection
      }

      // indicate to user that link was copied
      return this.$buefy.toast.open({
        duration: 2000,
        message: 'Link copied to clipboard!',
        type: 'is-success'
      });
    }
  }
}
